module.exports = __webpack_public_path__ + "site/img/16.fcdd638b.jpg";